import { Trans } from '@lingui/react/macro';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { normalizeToothIds } from '@videa/utils';

import { purple050 } from '../../../theme/videa-style-tokens';
import { useUniversalToFDI } from '../../../utils/internationalization/useUniversalToFDI';
import { colors } from '../../../utils/theme';
import { VideaTypography } from '../../elements/VideaTypography/VideaTypography';

const useStyles = makeStyles((theme) => ({
  p1Left: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  toothNumberInput: {
    fontSize: theme.spacing(2),
    fontWeight: 'bold',
    color: purple050,
    maxWidth: theme.spacing(3),
    padding: theme.spacing(0.5),
    textAlign: 'center',
  },
  toothNumberInputUnassigned: {
    fontSize: theme.spacing(2),
    fontWeight: 'bold',
    color: purple050,
    maxWidth: theme.spacing(3),
    padding: theme.spacing(0.5),
    textAlign: 'center',
  },
  textFieldWrapper: {
    display: 'flex',
  },
  toothNumberText: {
    fontFamily: 'proxima-nova, sans-serif',
    fontWeight: 500,
    paddingLeft: theme.spacing(1),
    color: 'white',
  },
  border: {
    borderBottom: `1px solid ${colors.VERY_LIGHT_GREY}`,
  },
}));

export const ToothNumberBox = (props: {
  toothNumber?: number | string;
  isFindingTypeVisible: boolean;
}) => {
  const { toothNumber, isFindingTypeVisible } = props;

  const classes = useStyles();
  const { displayToothNumber } = useUniversalToFDI();

  if (!isFindingTypeVisible) {
    return <></>;
  }

  return (
    // @ts-expect-error TS(2769): No overload matches this call.
    <Box
      display="flex"
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      <div className={classes.textFieldWrapper}>
        {normalizeToothIds(toothNumber) <= 0 ? (
          <VideaTypography
            variant="bodySmall"
            className={classes.toothNumberText}
          >
            <Trans>Tooth # unknown</Trans>
          </VideaTypography>
        ) : (
          <VideaTypography
            variant="bodySmall"
            className={classes.toothNumberText}
          >
            <Trans>Tooth {displayToothNumber(toothNumber)}</Trans>
          </VideaTypography>
        )}
      </div>
    </Box>
  );
};
